import { Component, h, Prop, State, Element, Watch } from '@stencil/core';

export declare interface JournalArticleTag {
  text?: string;
  url?: string;
}

/**
 * COMPNAME is for displaying a list of tags for a journal article.
 */
@Component({
  tag: 'aafp-journal-article-tag-list',
  shadow: false,
})
export class AafpJournalArticleTagList {
  /**
   * A JSON array of tags, each with: { "text": "", "url": "" }
   */
  @Prop() tags!: string;

  /**
   * A delimiter to display between each tag
   */
  @Prop() delimiter: string = '&nbsp;&nbsp;|&nbsp;&nbsp;';

  @State() tagsJson: Array<JournalArticleTag> = [];

  @Element() element: HTMLElement;

  componentWillLoad() {
    this.parseTagsProp(this.tags);
  }

  @Watch('tags')
  parseTagsProp(newValue: string) {
    if (newValue) {
      this.tagsJson = JSON.parse(newValue);
    }
  }

  render() {
    return (
      <div class="adl-journal-article-tag-list">
        <span class="adl-journal-article-tag-list__icon material-icons" aria-hidden="true">
          label
        </span>
        <div class="adl-journal-article-tag-list__list adl-body">
          {this.tagsJson.map((tag, index) => {
            const tagHtml = tag.url ? <a href={tag.url}>{tag.text}</a> : <span>{tag.text}</span>;
            const delimiter = index !== this.tagsJson.length - 1 ? <span innerHTML={this.delimiter} /> : null;

            return [tagHtml, delimiter];
          })}
        </div>
      </div>
    );
  }
}
